export default __webpack_public_path__ + "static/media/logo-next-white.d743ac64.svg";